import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { DealTodo } from '~/models/DealTodo';

const paths = {
  index: '/deals/:deal_id/deal_todos'
};

type TIndex = (id: number | null) => SwrReturnType<DealTodo[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealTodos = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    const { data, mutate, error } = useSWR<DealTodo[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
